<template>
  <v-card class="fill-height">
    <v-toolbar dark color="secondaryBackground">
      <v-container fluid>
        <v-row no-gutters align="center">
          <v-col sm="1">
            <v-btn dark @click="closeDialog" color="secondaryAction">
              <v-icon left>mdi-arrow-left</v-icon>
              {{ $t("storyHub.backToStoryHub") }}
            </v-btn>
          </v-col>
          <v-col sm="7">
            <h2>
              {{
                $t("chapter.editingChapterName", {
                  chapterName: truncateString(
                    chapter.name,
                    MAX_LENGTH_HEADER_NAME_CHARS
                  ),
                })
              }}
            </h2>
          </v-col>
          <v-col sm="2">
            <SaveChapterText
              @unsavedChanges="unsavedChanges = $event"
              @syncing="syncing = $event"
              @error="error = $event"
              :chapterIri="chapter.id"
              :text="text"
              ref="savechaptertext"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-toolbar>
    <EditChapterTipTap
      v-model="text"
      :initialText="initialText"
      :chapter="chapter"
    />
    <v-snackbar v-model="snackbar" top>
      {{ $t("forms.waitUntilChangesHaveSaved") }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          {{ $t("forms.close") }}
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar v-model="errorSnackbar" color="error" top>
      {{ $t("forms.theLatestAttemptFailed") }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="errorSnackbar = false">
          {{ $t("forms.close") }}
        </v-btn>
      </template>
    </v-snackbar>
    <DeleteConfirmationModal :deleteGuardNamespace="DELETE_GUARD_NAMESPACE" icon="mdi-alert-octagon"  />
  </v-card>
</template>
<script>
import EditChapterTipTap from "./EditChapterTipTap";
import SaveChapterText from "./SaveChapterText";
import { readMoreString } from "@/helpers/truncateString";
import hasDeleteGuard from "@/mixins/hasDeleteGuard";
export default {
  mixins: [hasDeleteGuard],
  components: {
    EditChapterTipTap,
    SaveChapterText,
  },
  props: {
    value: Boolean,
    chapter: Object,
  },
  mounted() {
    this.$store.commit(`${this.DELETE_GUARD_NAMESPACE}/setType`, 'chapterText')
  },
  methods: {
    closeDialog() {
      if (this.error) {
        this.$store.dispatch(`${this.DELETE_GUARD_NAMESPACE}/show`, {
          callback: () => {
            this.$router.back();
          },
        });
      } else if (this.syncing || this.unsavedChanges) {
        this.$refs.savechaptertext.shakeButton()
        this.snackbar = true;
      } else {
        this.$router.back();
      }
    },
    truncateString(string, length) {
      return readMoreString(string, length);
    },
    handleSavingError() {
      this.errorSnackbar = true;
    },
  },
  computed: {
    MAX_LENGTH_HEADER_NAME_CHARS() {
      return 20;
    },
  },
  data() {
    return {
      dialog: this.value,
      error: false,
      errorSnackbar: false,
      initialText: this.chapter.text,
      snackbar: false,
      syncing: false,
      text: this.chapter.text,
      unsavedChanges: false,
    };
  },
  watch: {
    dialog(newValue) {
      this.$emit("input", newValue);
    },
    value(newValue) {
      this.dialog = newValue;
    },
    chapter(newValue) {
      this.text = newValue.text;
      this.initialText = newValue.text;
    },
    error(newValue) {
      if (newValue) {
        this.handleSavingError();
      }
    },
  },
};
</script>
<style scoped>
h2 {
  color: var(--v-secondaryAction-base);
}
</style>